// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* styles.scss */
/* Стили для корневого контейнера */
.root-container {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  /* Стили для левой боковой панели */
}
.root-container .header {
  position: fixed;
  padding: 5px 20px;
  top: 0;
  right: 0;
  left: 250px;
  z-index: 10;
  background-color: white;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
.root-container .sidebar {
  display: flex;
  width: 250px;
  z-index: 10;
  background: #2a3042;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  padding-top: 70px;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  flex-direction: column;
  justify-content: space-between;
  /* Стили для списка */
}
.root-container .sidebar ul {
  list-style: none;
  padding: 0;
  /* Стили для элементов списка */
}
.root-container .sidebar ul li {
  margin-bottom: 10px;
  /* Стили для ссылок */
}
.root-container .sidebar ul li a {
  text-decoration: none;
  font-weight: bold;
  display: block;
  padding: 0.625rem 1.5rem;
  color: #79829c;
  position: relative;
  transition: all 0.4s;
  /* Стили при наведении на ссылку */
}
.root-container .sidebar ul li a:hover, .root-container .sidebar ul li a:focus, .root-container .sidebar ul li a.active {
  color: white;
}
.root-container .footer {
  display: none;
  bottom: 0;
  padding: 20px;
  position: absolute;
  right: 0;
  color: #74788d;
  left: 250px;
  height: 60px;
  background-color: #f2f2f5;
}
@media screen and (max-width: 768px) {
  .root-container .footer {
    position: static;
  }
}
.root-container .footer .footer-container {
  display: flex;
  justify-content: space-between;
}

/* Styles for table hover on currencygames page */
.cell-for-hover {
  display: flex;
  align-items: center;
  width: calc(100% + 20px);
  height: 100%;
  margin-left: -10px;
  margin-right: -10px;
  padding-left: 10px;
  padding-right: 10px;
}

.highlight-row {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.highlight-col {
  background-color: rgba(0, 0, 0, 0.04) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,gBAAA;AAEA,mCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EAaA,mCAAA;AAXF;AAAE;EACE,eAAA;EACA,iBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,mDAAA;AAEJ;AAEE;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,iBAAA;EACA,mDAAA;EACA,sBAAA;EACA,8BAAA;EAEA,qBAAA;AADJ;AAEI;EACE,gBAAA;EACA,UAAA;EAEA,+BAAA;AADN;AAEM;EACE,mBAAA;EACA,qBAAA;AAAR;AACQ;EACE,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EAEA,kCAAA;AAAV;AACU;EAGE,YAAA;AADZ;AAQE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AANJ;AAOI;EAVF;IAWI,gBAAA;EAJJ;AACF;AAMI;EACE,aAAA;EACA,8BAAA;AAJN;;AASA,iDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AANF;;AAQA;EACE,gDAAA;AALF;;AAOA;EACE,gDAAA;AAJF","sourcesContent":["/* styles.scss */\n\n/* Стили для корневого контейнера */\n.root-container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  min-height: 100vh;\n\n  .header {\n    position: fixed;\n    padding: 5px 20px;\n    top: 0;\n    right: 0;\n    left: 250px;\n    z-index: 10;\n    background-color: white;\n    box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);\n  }\n\n  /* Стили для левой боковой панели */\n  .sidebar {\n    display: flex;\n    width: 250px;\n    z-index: 10;\n    background: #2a3042;\n    bottom: 0;\n    margin-top: 0;\n    position: fixed;\n    top: 0;\n    padding-top: 70px;\n    box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);\n    flex-direction: column;\n    justify-content: space-between;\n\n    /* Стили для списка */\n    ul {\n      list-style: none;\n      padding: 0;\n\n      /* Стили для элементов списка */\n      li {\n        margin-bottom: 10px;\n        /* Стили для ссылок */\n        a {\n          text-decoration: none;\n          font-weight: bold;\n          display: block;\n          padding: 0.625rem 1.5rem;\n          color: #79829c;\n          position: relative;\n          transition: all 0.4s;\n\n          /* Стили при наведении на ссылку */\n          &:hover,\n          &:focus,\n          &.active {\n            color: white;\n          }\n        }\n      }\n    }\n  }\n\n  .footer {\n    display: none;\n    bottom: 0;\n    padding: 20px;\n    position: absolute;\n    right: 0;\n    color: #74788d;\n    left: 250px;\n    height: 60px;\n    background-color: #f2f2f5;\n    @media screen and (max-width: 768px) {\n      position: static;\n    }\n\n    .footer-container {\n      display: flex;\n      justify-content: space-between;\n    }\n  }\n}\n\n/* Styles for table hover on currencygames page */\n.cell-for-hover {\n  display: flex;\n  align-items: center;\n  width: calc(100% + 20px);\n  height: 100%;\n  margin-left: -10px;\n  margin-right: -10px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.highlight-row {\n  background-color: rgba(0, 0, 0, 0.04) !important;\n}\n.highlight-col {\n  background-color: rgba(0, 0, 0, 0.04) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
